/*

This script listens for click events on elements with the `data-plausible-event` attribute and sends a custom event to Plausible Analytics.

The `data-plausible-event` attribute should contain the name of the event to track. The `data-plausible-data` attribute can be used to pass additional data to the event.

*/

import { track, getElementFromEvent } from '../utils';

document.addEventListener('click', (e) => {
	const element = getElementFromEvent(e, '[data-plausible-event]');

	if (!element) {
		return;
	}

	const event = element.dataset.plausibleEvent;
	const data = JSON.parse(element.dataset.plausibleData || '{}');

	track(event, data);
});
